import {CommonModule} from '@angular/common';
import {ChangeDetectionStrategy, Component} from '@angular/core';

@Component({
    selector: 'app-fondo-cnr',
    standalone: true,
    imports: [
        CommonModule,
    ],
    template: `
        <div class="background-container">
            <img class="contenedor-principal" src="/assets/demo/images/logos/logo_cnr.png"
                 alt="Logo del CNR de El Salvador">
        </div>
    `,
    styleUrls: ['./fondo-cnr.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FondoCnrComponent {
}
